module.exports = __webpack_public_path__ + "static/media/twitter-widgets-logo.0251d8ee.png";